/**
 * Redux 스토어 설정
 */
import { createStore, combineReducers } from 'redux';
import { userReducer } from './reducers/userReducer.js';
import { postsReducer } from './reducers/postsReducer.js';
import { uiReducer } from './reducers/uiReducer.js';

// 루트 리듀서
const rootReducer = combineReducers({
  user: userReducer,
  posts: postsReducer,
  ui: uiReducer
});

// 스토어 생성
export const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// 상태 변경 구독 및 로깅
store.subscribe(() => {
  console.log('스토어 상태 업데이트:', store.getState());
});

export default store; 